import { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import { FormContext, FormContextType } from '../../../form/FormContext';
import { ApprovalInputViewModel } from '../../types';

export interface ApprovalInputValidityObserverProps {
    onApprovalInputValidityChange: Dispatch<SetStateAction<boolean>>;
}

export default function ApprovalInputValidityObserver({
    onApprovalInputValidityChange
}: ApprovalInputValidityObserverProps) {
    const { validation: { isValid = false } = {} } = useContext<FormContextType<ApprovalInputViewModel>>(FormContext);

    useEffect(() => {
        onApprovalInputValidityChange((prevIsValid) => {
            if (prevIsValid === isValid) {
                return prevIsValid;
            }

            return isValid;
        });
    }, [isValid, onApprovalInputValidityChange]);

    return null;
}
